var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 21.862,
    height: 16.113,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M14 16a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm0 2a4 4 0 1 1 4-4 4 4 0 0 1-4 4zm-4.24.24a6 6 0 0 0 8.48 0L22.47 14l-4.24-4.22a6 6 0 0 0-8.48 0L5.49 14l4.25 4.24Zm9.9 1.42a8 8 0 0 1-11.32 0l-4.94-5a1 1 0 0 1 0-1.42l4.95-5a8 8 0 0 1 11.32 0l5 5a1 1 0 0 1 0 1.42l-5 5z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-1",
    style: {
      fill: "none"
    },
    d: "M.09 0h28v28h-28z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:none}"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)",
    id: "g16",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path)"
    },
    transform: "translate(-3.104 -5.894)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)",
    id: "g14",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1,
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#9cad4c",
      fillOpacity: 1
    },
    d: "M-1.91 1H29.9v26.02H-1.91z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.21afd3678d89c250bba91c403c63603e.svg";
export { ForwardRef as ReactComponent };